import './Alert.scss';

import { useEffect } from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { hideAlert } from "../../slices/alertSlice";

export const Alert = () => {
    const dispatch = useDispatch();
    const showAlert = useSelector((state) => state.alert.showAlert);
    const alertType = useSelector((state) => state.alert.alertType);
    const alertMessage = useSelector((state) => state.alert.alertMessage);

    useEffect(() => {
        if (showAlert) {
            console.log("Alert shown. Timer started.");
            const timeout = setTimeout(() => {
                dispatch(hideAlert());
            }, 15000);

            return () => {
                console.log("Cleaning up timer.");
                clearTimeout(timeout);
            }
        }
    }, [showAlert, dispatch]);


    return (
        <div className={`alert ${alertType}`}>
            <div className={"alert_description"}>
                {alertMessage}
            </div>
        </div>
    );
};